'use client';

import { getColorScheme } from '@/utils/getColorScheme';
import { getVerticalSpacing } from '@/utils/getVerticalSpacing';
import { MarkDown } from './atoms/MarkDown';

function Feature(props) {
    const { Icon, Description, iconColor } = props;

    return (
        <div className="relative pl-9">
            <div className={`inline font-bold text-neutral-800`}>
                <i
                    className={`${Icon} absolute left-0 top-0.5 text-2xl ${iconColor}`}
                />
            </div>
            <div>
                <MarkDown className="font-text">{Description}</MarkDown>
            </div>
        </div>
    );
}

export default function Privacy(props) {
    const {
        Tagline,
        Header,
        Body,
        InformationHeader,
        InformationBody,
        List,
        AccessHeader,
        AccessBody,
        AccessList,
        SecurityHeader,
        SecurityBody,
        UpdatesHeader,
        UpdatesBody,
        ColorScheme = 'white',
        VerticalSpacing = 'medium',
    } = props;

    const {
        backgroundColor,
        textColor,
        headerColor,
        iconColor,
        backgroundStyle,
    } = getColorScheme(ColorScheme, props.GradientDirection);

    const vSpace = getVerticalSpacing(VerticalSpacing);

    return (
        <section
            className={`editable-component relative ${backgroundColor} ${vSpace} px-6 lg:px-8`}
            style={{
                ...backgroundStyle,
                marginTop: '-172px',
                '@media (minWidth: 768px)': { marginTop: '-70px' },
            }}
            data-json="privacy"
        >
            <div
                className={`relative z-40 mx-auto max-w-3xl px-6 pt-20 text-base leading-7 ${textColor} lg:px-8 lg:pt-24`}
            >
                <MarkDown
                    variant="h1"
                    className={`font-display text-base uppercase leading-7 tracking-wide ${headerColor}`}
                >
                    {Tagline}
                </MarkDown>

                <MarkDown
                    variant="h2"
                    className={`mt-2 font-display text-2xl tracking-tight ${headerColor} md:text-3xl lg:text-4xl`}
                >
                    {Header}
                </MarkDown>

                <div className="mt-10 max-w-2xl">
                    <MarkDown className="font-text">{Body}</MarkDown>

                    <ul
                        role="list"
                        className={`mt-5 max-w-xl space-y-2 font-text ${textColor}`}
                    >
                        {List.map((feature) => (
                            <Feature
                                key={feature}
                                {...feature}
                                iconColor={iconColor}
                            />
                        ))}
                    </ul>

                    <MarkDown
                        variant="h2"
                        className={`mt-10 font-display text-2xl tracking-tight ${headerColor}`}
                    >
                        {InformationHeader}
                    </MarkDown>
                    <MarkDown className="mt-6 font-text">
                        {InformationBody}
                    </MarkDown>

                    <MarkDown
                        variant="h2"
                        className={`mt-10 font-display text-2xl tracking-tight ${headerColor}`}
                    >
                        {AccessHeader}
                    </MarkDown>
                    <MarkDown className="mt-6 font-text">{AccessBody}</MarkDown>

                    <ul
                        role="list"
                        className={`mt-5 max-w-xl space-y-2 font-text ${textColor}`}
                    >
                        {AccessList.map((feature) => (
                            <Feature
                                key={feature}
                                {...feature}
                                iconColor={iconColor}
                            />
                        ))}
                    </ul>

                    <MarkDown
                        variant="h2"
                        className={`mt-10 font-display text-2xl tracking-tight ${headerColor}`}
                    >
                        {SecurityHeader}
                    </MarkDown>
                    <MarkDown className="mt-6 font-text">
                        {SecurityBody}
                    </MarkDown>

                    <MarkDown
                        variant="h2"
                        className={`mt-10 font-display text-2xl tracking-tight ${headerColor}`}
                    >
                        {UpdatesHeader}
                    </MarkDown>
                    <MarkDown className="mt-6 font-text">
                        {UpdatesBody}
                    </MarkDown>
                </div>
            </div>
        </section>
    );
}
